import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#222747",
    },
    secondary: {
      main: "#DD7153",
    },
  },
  typography: {
    fontFamily: ['Nunito Sans', 'Merriweather','Montserrat'].join(","),
  },
});

export default theme;